const $ = window.jQuery;
import Navigo from "navigo";
import utils from "./utils";

export default class Router {
    constructor(store) {
        this.store = store;
        this.initNavigo();
        this.initLinks();
        this.initForms();

        this.silent = false;
    }

    initNavigo() {
        this.navigo = new Navigo(globals.rootUrl, false);
        this.navigo
            .on({
                "*": () => {
                    if (!this.silent) {
                        this.store.trigger("router:main-route-fired");
                    }
                    this.silent = false;
                },
            })
            .resolve();
    }

    initForms() {
        $(document).on("submit", 'form[method="get"]', (e) => {
            e.preventDefault();
            var $form = $(e.target);
            var action = $form.attr("action");
            var query = $form.serialize();
            var url = `${action}?${query}`;

            this.navigate(url);
        });
    }

    initLinks() {
        $(document).on("click", "a", (e) => {
            if (!this.isRoutableEvent(e)) {
                return true;
            }

            e.preventDefault();
            var $el = $(e.target);
            var $anchor = $el.closest("a");
            var href = $.trim($anchor.attr("href"));

            href = utils.addTrailingSlash(href);

            if (!$el.hasClass("history-back")) {
                this.store.trigger("router:forward-link-clicked", {
                    href: href,
                });
            }

            this.navigate(href);
        });
    }

    navigate(url, silent = false) {
        this.silent = silent;
        // url = url.split('#/').join('');
        // console.log( url );
        this.navigo.navigate(url, true);
    }

    isRoutableEvent(evt) {
        var $el = $(evt.target);
        var $anchor = $el.closest("a");
        var href = $.trim($anchor.attr("href"));
        var target = $.trim($anchor.attr("target"));

        if (evt.metaKey || evt.ctrlKey || evt.altKey || evt.shiftKey) {
            return false;
        }

        if (
            href.indexOf("#") !== -1 ||
            href.indexOf("##") !== -1 ||
            href.indexOf("/core/") !== -1
        ) {
            return false;
        }

        if ("_blank" === target) {
            return false;
        }

        var isFileLink =
            /^(http|https):\/\/\S+?\.(gif|zip|jpg|jpeg|pdf|png)/g.test(href);
        if (isFileLink) {
            return false;
        }

        var isSpecialLink = /^(mailto:|tel:)/.test(href);
        if (isSpecialLink) {
            return false;
        }

        var isExternalLink = utils.isExternalUrl(href);
        if (isExternalLink) {
            return false;
        }

        var bypassRouter = $anchor.hasClass("bypass-router");
        if (bypassRouter) {
            return false;
        }

        return true;
    }
}
